const data = {
  title: "Floor 2-4",
  musicTrack: "MUSIC_WORLD2",
  theme: "GREEN",
  tilesWidth: 9,
  tilesHeight: 9,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 5,
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 8,
      y: 5,
    },
    {
      type: "ENEMY_SPAWN",
      x: 8,
      y: 4,
      direction: "LEFT",
      enemyType: "ENEMY",
    },
    {
      type: "ENEMY_SPAWN",
      x: 8,
      y: 3,
      direction: "LEFT",
      enemyType: "ENEMY",
    },
    {
      type: "ENEMY_SPAWN",
      x: 8,
      y: 2,
      direction: "LEFT",
      enemyType: "ENEMY",
    },
    {
      type: "ENEMY_SPAWN",
      x: 8,
      y: 6,
      direction: "LEFT",
      enemyType: "ENEMY",
    },
    {
      type: "ENEMY_SPAWN",
      x: 8,
      y: 7,
      direction: "LEFT",
      enemyType: "ENEMY",
    },
    {
      type: "ENEMY_SPAWN",
      x: 8,
      y: 8,
      direction: "LEFT",
      enemyType: "ENEMY",
    },
    {
      type: "ENEMY_SPAWN",
      x: 1,
      y: 8,
      direction: "UP",
      enemyType: "ENEMY",
    },
    {
      type: "ENEMY_SPAWN",
      x: 9,
      y: 8,
      direction: "UP",
      enemyType: "ENEMY",
    },
    {
      type: "CHIP",
      x: 3,
      y: 3,
    },
    {
      type: "CHIP",
      x: 3,
      y: 7,
    },
    {
      type: "CHIP",
      x: 7,
      y: 7,
    },
    {
      type: "CHIP",
      x: 7,
      y: 3,
    },
    {
      type: "CHIP",
      x: 5,
      y: 5,
    },
    {
      type: "WALL",
      x: 6,
      y: 5,
    },
    {
      type: "WALL",
      x: 4,
      y: 5,
    },
    {
      type: "WALL",
      x: 8,
      y: 1,
    },
    {
      type: "WALL",
      x: 2,
      y: 1,
    },
    {
      type: "WALL",
      x: 2,
      y: 9,
    },
    {
      type: "WALL",
      x: 8,
      y: 9,
    },
    {
      type: "WALL",
      x: 3,
      y: 5,
    },
    {
      type: "WALL",
      x: 7,
      y: 5,
    },
    {
      type: "WALL",
      x: 3,
      y: 1,
    },
    {
      type: "WALL",
      x: 4,
      y: 1,
    },
    {
      type: "WALL",
      x: 5,
      y: 1,
    },
    {
      type: "WALL",
      x: 6,
      y: 1,
    },
    {
      type: "WALL",
      x: 7,
      y: 1,
    },
    {
      type: "WALL",
      x: 3,
      y: 9,
    },
    {
      type: "WALL",
      x: 4,
      y: 9,
    },
    {
      type: "WALL",
      x: 5,
      y: 9,
    },
    {
      type: "WALL",
      x: 6,
      y: 9,
    },
    {
      type: "WALL",
      x: 7,
      y: 9,
    },
  ],
};

export default data;
